var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCommunication = function SvgCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#communication_svg__a)",
    stroke: "currentcolor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.465 18.883v7c0 .454-.017.892-.07 1.312-.402 4.725-3.185 7.07-8.313 7.07h-.7c-.437 0-.857.21-1.12.56l-2.1 2.8c-.927 1.242-2.432 1.242-3.36 0l-2.1-2.8c-.227-.297-.735-.56-1.12-.56h-.7c-5.582 0-8.382-1.383-8.382-8.383v-7c0-5.127 2.363-7.91 7.07-8.312.42-.053.857-.07 1.313-.07h11.2c5.582 0 8.382 2.8 8.382 8.383Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.465 11.883v7c0 5.145-2.362 7.91-7.07 8.312.053-.42.07-.858.07-1.313v-7c0-5.582-2.8-8.382-8.382-8.382h-11.2c-.455 0-.893.018-1.313.07.403-4.707 3.185-7.07 8.313-7.07h11.2c5.582 0 8.382 2.8 8.382 8.383Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.617 23.188h.016M17.492 23.188h.016M11.367 23.188h.016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "communication_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h42v42H0z"
  })))));
};

export default SvgCommunication;